import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowTrendUp, faArrowTrendDown } from "@fortawesome/free-solid-svg-icons";

interface HighProducts {
  highMoving: any[];
  lowMoving: any[];
}

const HighAndLowMovingProducts = ({ highMoving, lowMoving }: HighProducts) => {
  return (
    <div className="w-full h-full flex flex-col gap-5 overflow-hidden">
      {/* High Moving Products */}
      <div className="bg-white dark:bg-gray-800 rounded-lg p-4 border-l-4 border-green-500 shadow-sm">
        <div className="flex items-center justify-between mb-4">
          <h2 className="text-md font-semibold text-gray-800 dark:text-white">High Moving Products</h2>
          <span className="p-2 bg-green-100 dark:bg-green-900 rounded-full">
            <FontAwesomeIcon icon={faArrowTrendUp} className="text-green-600 dark:text-green-400" />
          </span>
        </div>

        {highMoving && highMoving.length > 0 ? (
          <div className="space-y-3">
            {highMoving.map((item) => (
              <div
                className="flex items-center justify-between py-2 border-b border-gray-100 dark:border-gray-700 last:border-0"
                key={item.productName}
              >
                <span className="font-medium text-gray-700 dark:text-gray-300">{item.productName}</span>
                <span className="px-3 py-1 bg-green-100 dark:bg-green-900 text-green-700 dark:text-green-300 text-sm font-medium rounded-full">
                  {item.count}
                </span>
              </div>
            ))}
          </div>
        ) : (
          <div className="text-center py-4 text-gray-500 dark:text-gray-400">No data available</div>
        )}
      </div>

      {/* Low Moving Products */}
      <div className="bg-white dark:bg-gray-800 rounded-lg p-4 border-l-4 border-red-500 shadow-sm">
        <div className="flex items-center justify-between mb-4">
          <h2 className="text-md font-semibold text-gray-800 dark:text-white">Low Moving Products</h2>
          <span className="p-2 bg-red-100 dark:bg-red-900 rounded-full">
            <FontAwesomeIcon icon={faArrowTrendDown} className="text-red-600 dark:text-red-400" />
          </span>
        </div>

        {lowMoving && lowMoving.length > 0 ? (
          <div className="space-y-3">
            {lowMoving.map((item) => (
              <div
                className="flex items-center justify-between py-2 border-b border-gray-100 dark:border-gray-700 last:border-0"
                key={item.productName}
              >
                <span className="font-medium text-gray-700 dark:text-gray-300">{item.productName}</span>
                <span className="px-3 py-1 bg-red-100 dark:bg-red-900 text-red-700 dark:text-red-300 text-sm font-medium rounded-full">
                  {item.count}
                </span>
              </div>
            ))}
          </div>
        ) : (
          <div className="text-center py-4 text-gray-500 dark:text-gray-400">No data available</div>
        )}
      </div>
    </div>
  );
};

export default HighAndLowMovingProducts;
